$(document).ready(() => {
  const $heroElementVideo = $('.big-hero-with-image-block__image--with-video');

  if ($heroElementVideo.length) {
    imageOrVideo();
    $(window).resize(debounce(imageOrVideo));
  }

  function showImageInsteadOfVideo() {
    const $img = $heroElementVideo.find('img');
    if (!$img.attr('src')) {
      $img.attr('src', $img.attr('data-src'));
    }
  }
  function showVideo() {
    const $video = $heroElementVideo.find('video');
    if (!$video.attr('src')) {
      $video.attr('src', $video.attr('data-src'));
    }
  }
  function imageOrVideo() {
    if (window.innerWidth >= 722) {
      showVideo();
    }
    else {
      showImageInsteadOfVideo();
    }
  }
  function debounce(callback) {
    let timeout;

    return (argument) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => callback(argument), 500);
    };
  };
});